
import { Options, Vue } from "vue-class-component";
import { readTaskSimpleRecords } from "@/store/task/getters";
import { store } from "@/store";
import { dispatchSimpleTaskRecords } from "@/store/task/actions";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import { dateConversion, getLocalProject, typeConversion } from "@/utils";

// 任务执行详情页面
@Options({
  components: {
    SideMenu,
  },
})
export default class TaskRecord extends Vue {
  // 部分列表字段其他字段在template里直接定义了)
  public TaskFields = [
    { label: "开始时间", prop: "start" },
    { label: "结束时间", prop: "end" },
    { label: "执行者", prop: "create_user" },
  ];
  // 列表过滤条件：任务名称、状态、执行者
  public name_search: string | "" = "";
  public status_search: number | "" = "";
  public user_search: string | "" = "";

  public loading = false;
  public currentPage1 = 1;
  public record = 16; //记录条数

  // 任务执行状态
  public task_record_status = {
    0: "空闲",
    1: "进行中",
    2: "暂停",
    3: "完成",
    4: "取消",
    5: "异常",
  };

  public status_options = [
    {
      label: "空闲",
      value: 0,
    },
    {
      label: "进行中",
      value: 1,
    },
    {
      label: "暂停",
      value: 2,
    },
    {
      label: "完成",
      value: 3,
    },
    {
      label: "取消",
      value: 4,
    },
    {
      label: "异常",
      value: 5,
    },
  ];
  // 从本地缓存获取数据
  public project = Number(getLocalProject());
  public async mounted() {
    this.loading = true;
    const project = this.project;
    await dispatchSimpleTaskRecords(store, {
      project: Number(getLocalProject()),
      task_name: "",
      task_status: "",
      create_user: "",
      page: 1,
      size: this.record,
    });
    this.loading = false;
  }

  public handleDetail(row: any, event: any, colume: any) {
    // this.$router.push({
    //     path:'/taskDetails',
    //     query:{
    //         id:row.id,
    // }})
    const { href } = this.$router.resolve({
      path: "/taskDetails",
      query: {
        id: row.id,
      },
    });
    window.open(href, "_blank");
    return Promise.resolve(false); // 不刷新表格
  }

  public get get_data() {
    return this.getTaskRecords();
  }

  //读取任务记录列表数据
  getTaskRecords() {
    const taskRecords: any = readTaskSimpleRecords(store);
    for (let record of taskRecords.results) {
      record.last_executor = record.executor || "-";
      record.readable_status = typeConversion(
        record?.status,
        this.task_record_status
      );
      const start_date = dateConversion(record.start_date);
      const end_date = dateConversion(record.end_date);
      record.start = start_date;
      record.end = end_date;
      record.start_timestamp = new Date(record.start_date).getTime();
      record.end_timestamp = new Date(record.end_date).getTime();
    }
    return taskRecords;
  }

  public async onClear() {
    this.name_search = "";
    this.status_search = "";
    this.user_search = "";
    this.currentPage1 = 1;
    this.loading = true;
    await dispatchSimpleTaskRecords(store, {
      project: this.project,
      task_name: this.name_search,
      task_status: this.status_search,
      create_user: this.user_search,
      page: 1,
      size: this.record,
    });
    this.loading = false;
  }

  // 查询，分页
  public async onSearch(operation: any) {
    this.loading = true;
    await dispatchSimpleTaskRecords(store, {
      project: this.project,
      task_name: this.name_search,
      task_status: this.status_search,
      create_user: this.user_search,
      page: operation === "Search" ? 1 : this.currentPage1,
      size: this.record,
    });
    this.loading = false;
  }
}
